import React from "react";
import styled, { css } from "styled-components";
import { Label, LabelH2, P } from "@motorata/base-ui.components.atoms.typography";
import { Row } from "@motorata/base-ui.components.atoms._atoms";
import Link from "@motorata/next.components.atoms.link";
import { ProfileType } from "@motorata/base-ui.types.api";
import { addSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string";
import Image from "../common/Image";
import { Box } from "../common/_atoms";

export const ProfileBlockLoader = () => {
  return (
    <LoaderWrapper>
      <Box className="text_wrapper">
        <Box className="title gradient" />
        <Box className="rate gradient" />
      </Box>
    </LoaderWrapper>
  );
};

const ProfileBlock = ({ profile }: {
  profile: ProfileType
}) => {
  return (
    <Wrapper>
      <Box>
        <Row marginBottom="S">
          {
            profile?.images?.profile?.src &&
            <ProfileImageWrapper>
              <Image
                width={50}
                height={50}
                src={profile?.images?.profile.src}
                priority={false}
                alt="dec"
                style={{
                  objectFit: "contain"
                }}
              />
            </ProfileImageWrapper>
          }
          <Box>
            <LabelH2 marginBottom="XXS">
              {profile.name}
            </LabelH2>
            <Label type="third" icon="location-fill">
              {profile.address?.city}, {profile.address?.province}
            </Label>
          </Box>
        </Row>
        {
          profile.description &&
          <P
            small>{profile.description.length < 250 ? profile.description : `${profile.description.substring(0, 250)}...`}</P>
        }
      </Box>
      <StyledGrid justifyContent="flex-end">
        {
          profile.phone ?
            <Link type="secondary" href={`tel:${profile.phone}`} icon="phone-fill">
              {addSpacesFromPhoneNumber(profile.phone)}
            </Link> :
            <Box></Box>
        }
        <Link type="primary" href={`/${profile.slug}`}>
          Zobacz profil
        </Link>
      </StyledGrid>
    </Wrapper>
  );
};

export default ProfileBlock;

const StyledGrid = styled(Box)`
  display: grid;
  width: max-content;
  grid-template-columns: 1fr 1fr;
  margin-top: ${({ theme }) => theme.space.S};
  grid-gap: ${({ theme }) => theme.space.XS};
  margin-left: auto;

  @media (max-width: 800px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;

const ProfileImageWrapper = styled.div`
  border-radius: 50%;
  height: 60px;
  width: 60px;
  min-height: 60px;
  min-width: 60px;
  overflow: hidden;
  margin-right: ${({ theme }) => theme.space.S};
  position: relative;
  background: ${({ theme }) => theme.color.background};
  border: 5px solid ${({ theme }) => theme.color.background};
`;

const Wrapper = styled(Box)`
  overflow: hidden;
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  background: white;
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
  border: 1px solid ${({ theme }) => theme.color.fourth};
  padding: ${({ theme }) => theme.space.S};
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ column }) =>
          column &&
          css`
            flex-direction: column;
          `};

  @media (max-width: 800px) {
    flex-direction: column;
  }

  @media (max-width: 600px) {
    width: 100vw;
    border-radius: 0;
    margin-left: calc((100vw - 100%) / -2);
    margin-left: -webkit-calc((100vw - 100%) / -2);
    margin-left: -moz-calc((100vw - 100%) / -2);
  }
`;

const LoaderWrapper = styled(Box)`
  height: 190px;
  padding: 10px;
  background: white;
  border-radius: 5px;
  display: flex;
  align-items: stretch;

  .text_wrapper {
    width: 100%;
    height: 100%;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .title {
      height: 55px;
      width: 50%;
      border-radius: 5px;
    }

    .rate {
      height: 55px;
      width: 100%;
      border-radius: 5px;
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;
  }

  .gradient {
    animation-duration: 1.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
    background-size: 1000px 640px;

    position: relative;
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`;
